module.exports = __webpack_public_path__ + "static/img/howto_03.9085b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c16/howto_03.png
// module id = P3Ki
// module chunks = 0